<template>
  <div id="app">
    <app-header
      :app-title="headerName.appTitle"
      :app-subtitle="headerName.appSubtitle"
      :branding-image="{ src: cityLogo }"
      :appLink="computeLink"
    >
    <mobile-nav 
      :links="footerLinks"
      slot="mobile-nav"
    >
    </mobile-nav>
    </app-header>
    <main
      class="container main"
      :class="containerClass"
    >
      <router-view />
    </main>
    <app-footer :links="footerLinks">
    </app-footer>
  </div>
</template>

<script>
import cityLogo from '../src/assets/city-of-philadelphia.png'
export default {
  name: 'App',
  data() { 
    return {
      footerLinks: [
        {
          text: "Department of Licenses & Inspections", //the route name is used, and not the path
          href: "https://www.phila.gov/departments/department-of-licenses-and-inspections/", //the route name is used, and not the path
          type: 'native', //any other html anchor attributes
          attrs: {target: "_blank"},
        },
        {
          text: "Terms of Use", //the route name is used, and not the path
          href: "https://www.phila.gov/terms-of-use/", //the route name is used, and not the path
          type: 'native', //any other html anchor attributes
          attrs: {target: "_blank"},
        },
        {
          text: "Right to Know", //the route name is used, and not the path
          href: "https://www.phila.gov/documents/pennsylvania-right-to-know-law-and-disclosure-of-public-documents/", //the route name is used, and not the path
          type: 'native', //any other html anchor attributes
          attrs: {target: "_blank"},
        },
        {
          text: "Privacy Policy", //the route name is used, and not the path
          href: "https://www.phila.gov/privacypolicy/", //the route name is used, and not the path
          type: 'native', //any other html anchor attributes
          attrs: {target: "_blank"},
        },

      ]
    }
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    containerClass() {
      let value = '';
      if (this.routeName === 'contractor-lookup') {
        value = 'wider-container';
      }
      return value;
    },
    computeLink(){
      return this.$store.state.appealsCalendar.zba ? 'https://www.phila.gov/departments/zoning-board-of-adjustment/' : '/';
    },
    cityLogo(){
      return cityLogo;
    },
    headerName() {
      // console.log(this.$router.currentRoute)
      if (this.$store.state.headerProps === 'propertyHistory') {
        return {
          appTitle: "Property History",
          appSubtitle: "Permits, licenses, violations & appeals by address",
        };
      }
      if (this.$store.state.headerProps === 'contractorLookup') {
        return {
          appTitle: "Find a Licensed Contractor",
          appSubtitle: "Search for contractors and tradespeople",
        };
      }
      if (this.$store.state.headerProps === 'contractorPermitLookup') {
        return {
          appTitle: "Contractor Permit Lookup",
          appSubtitle: "View the status of your permits",
        };
      }
      if (this.$store.state.headerProps === 'appealsCalendar') {
        return {
          appTitle: "L&I Appeals Calendar",
          appSubtitle: "See dates and agendas for L&I appeal hearings",
        };
      }
      if (this.$store.state.headerProps === 'permitApplicationTracker') {
        return {
          appTitle: "Permit Application Tracker",
          appSubtitle: "Track the status of your L+I permit application",
        };
      }
      if (this.$store.state.headerProps === 'zbaCalendar') {
        return {
          appTitle: "Zoning Board of Adjustment (ZBA) Appeals Calendar",
          appSubtitle: "See dates and agendas for ZBA appeal hearings",
        };
      }
      return {
          appTitle: "L&I Lookup Resources",
          appSubtitle: null,
        };
    }
  },
};
</script>

<style lang="scss">
  @import "@/assets/scss/main.scss";
  div.search-bar>div>h1.is-size-3 {
    padding-top: 15px;
    padding-left: 10px;
  }
  @media (min-width: $tablet) {
    main>div {
      // margin: 0 40px 0 40px;
      div.columns.is-12 {
        margin-top: 0rem;
        height: auto;
      }
    }

  }
  a.is-current.pagination-link:not(.app-title) {
    background-color: $ben-franklin-blue-dark ;
  }
  a:not(.is-current):not(.app-title), .is-link {
      color: $ben-franklin-blue-dark ;
    }
  li.is-current{
    color: $ben-franklin-blue-dark;
  }
</style>
